import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { Typography } from '@mui/material'
import { BottomDrawer, PULLER_HEIGHT } from '$common/bottom-drawer'
import { UserListItem } from '$common/user-list-item'
import { getCurrentLanguage, t } from '$i18n'
import { formatClock } from '$func/time'
import { openUserProfile } from '$logic/router'
import { ReceivedIcon } from '$common/icons/received'
import { isRecentDate } from '$func/date'

function SeenListItem({
  viewer,
}: {
  viewer: { userId: string; seenAt: Date }
}) {
  const date = new Date(viewer.seenAt)
  const { isToday, isYesterday } = isRecentDate(date)

  const day = date.toLocaleString(getCurrentLanguage(), {
    day: 'numeric',
  })
  const month = date.toLocaleString(getCurrentLanguage(), {
    month: 'long',
  })
  const joinTime = isToday
    ? `${t('seenListModal.today')} ${formatClock(date)}`
    : isYesterday
    ? `${t('seenListModal.yesterday')} ${formatClock(date)}`
    : `${t('seenListModal.customDate')(`${day} ${month}`, formatClock(date))}`

  const secondaryText = (
    <span style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
      <ReceivedIcon
        sx={{ viewBox: '0 0 16px 16px', width: '16px', height: '16px' }}
      />
      <Typography variant="caption1" noWrap color="gray">
        {joinTime}
      </Typography>
    </span>
  )
  return (
    <UserListItem
      userId={viewer.userId}
      secondaryText={secondaryText}
      onClick={async () => {
        await closeCurrentModal()
        openUserProfile(viewer.userId)
      }}
    />
  )
}

export function MessageSeenListDrawer({
  viewers,
  onClose,
  isOpen,
}: {
  viewers: { userId: string; seenAt: Date }[]
  onClose: () => unknown
  isOpen?: boolean
}) {
  return (
    <BottomDrawer onClose={onClose} isOpen={isOpen}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: `calc(100% - ${PULLER_HEIGHT}px)`,
        }}
      >
        <Typography variant="subtitle1" color="primary" margin="8px 12px">
          {t('contextMenu.haveSeen')(viewers.length)}
        </Typography>
        {viewers.map(viewer => (
          <SeenListItem viewer={viewer} />
        ))}
      </div>
    </BottomDrawer>
  )
}

MessageSeenListDrawer.defaultProps = {}
